import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import KanbanCard from './KanbanCard';
import { Typography, IconButton } from '@material-ui/core';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';

const useStyles = makeStyles(theme => ({
  column: {
    backgroundColor: 'rgba(243, 244, 246, 0.5)',
    borderRadius: 4,
    border: '1px solid #e5e7eb',
    minWidth: 280,
    maxWidth: 280,
    marginRight: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    overflow: 'hidden',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
  },
  colorBar: props => ({
    height: '4px',
    backgroundColor: props.color || '#757575',
    flexShrink: 0,
  }),
  columnInner: {
    padding: theme.spacing(1.5),
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  columnHeader: {
    marginBottom: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  columnHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    gap: 4,
  },
  columnTitle: {
    fontWeight: 600,
    fontSize: '0.875rem',
    color: '#111827',
  },
  ticketCount: {
    fontSize: '0.8rem',
    color: '#6b7280',
    fontWeight: 400,
  },
  cardList: {
    flexGrow: 1,
    overflowY: 'auto',
    ...theme.scrollbarStyles,
    minHeight: 150,
    maxHeight: 'calc(100vh - 220px)',
  },
  dragHandle: {
    cursor: 'grab',
    color: '#9ca3af',
    padding: theme.spacing(0.5),
    '&:hover': {
      color: '#6b7280',
    },
  },
}));

const KanbanColumn = ({ id, title, tickets, color, index, updateTicket, isAdmin }) => {
  const classes = useStyles({ color });

  return (
    <Draggable draggableId={'col-' + id} index={index}>
      {(provided, snapshot) => (
        <div
          className={classes.column}
          ref={provided.innerRef}
          {...provided.draggableProps}
        >
          <div className={classes.colorBar} />
          <div className={classes.columnInner}>
            <div className={classes.columnHeader}>
              <div className={classes.columnHeaderLeft}>
                {isAdmin && (
                  <div
                    {...provided.dragHandleProps}
                    className={classes.dragHandle}
                  >
                    <DragIndicatorIcon fontSize="small" />
                  </div>
                )}
                <Typography className={classes.columnTitle}>{title}</Typography>
                <Typography className={classes.ticketCount}>
                  ({tickets.length})
                </Typography>
              </div>
            </div>
            <Droppable droppableId={id} type="CARD">
              {(provided, snapshot) => (
                <div
                  className={classes.cardList}
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  {tickets.map((ticket, index) => (
                    <KanbanCard
                      key={ticket.id}
                      ticket={ticket}
                      index={index}
                      updateTicket={updateTicket}
                    />
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </div>
        </div>
      )}
    </Draggable>
  );
};

export default KanbanColumn;
